import React, {Component} from 'react'
import {Accordion, Icon, Grid, Popup} from 'semantic-ui-react'
import {formatDate} from '../cads/format-date'
import {_rep} from '../cads/unminify'
import {filterSalesOrdersCadCard} from './filter-sales-orders'
import {showOrderMargin, orderMarginPercent} from './order-margin'
import {ticketChipPopup} from './ticket-chip-popup'
import {poeChipPopup} from './poe-chip-popup'

const colStyle = {textOverflow: 'ellipsis', overflow: 'hidden'}

const setReadyToShip = (orders, cad) => {
  let onHand = cad.y == null ? 0 : cad.y
  if (onHand > 0) {
    orders = orders.map((orderOriginal, index) => {
      let order = JSON.parse(JSON.stringify(orderOriginal))
      let qty = Number(order.quantity)
      if (onHand > 0 && (qty * 0.9) < onHand) {
        order['rts'] = true
        onHand -= qty
      }
      return order
    })

    return orders
  } else {
    return orders
  }
}

const longDash = <span style={{opacity: 0.05}}> — </span>

class SalesOrderAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {active: false}
  }

  toggleAccordion = () => this.setState({active: !this.state.active})

  render() {
    let {estimates, salesOrderDataByStyleNumber, salesOrderDataById, contact, fromDate, toDate, orderType, expandAll, cad, atsRep, ticketInfo, poeInfo, showFields} = this.props
    let {active} = this.state

    let marginCad = showOrderMargin(showFields) ? cad : null
    let atsRepData = atsRep == null ? null : atsRep[cad.i]

    let orders = (
      salesOrderDataByStyleNumber == null ? [] : salesOrderDataByStyleNumber
    ).concat(
      salesOrderDataById == null ? [] : salesOrderDataById
    ).sort((a, b) => {return a.date > b.date ? 1 : -1})

    if (estimates != null) {
      orders = estimates
    }

    orders = filterSalesOrdersCadCard(orders, contact, fromDate, toDate)

    switch (orderType) {
      case 'PO':
        orders = orders.filter(y => !y.hold && !y.worksheet && !y.pending_po)
        orders = setReadyToShip(orders, cad)
        break;
      case 'Hold':
        orders = orders.filter(y => y.hold)
        break;
      case 'Worksheet':
        orders = orders.filter(y => y.worksheet)
        break;
      case 'Pending PO':
        orders = orders.filter(y => y.pending_po)
        break;
      default:
        // Code to be executed if no case matches
    }

    const totalSalesOrder = orders.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.quantity)
    }, 0)

    if (expandAll) {
      active = true
    }

    return (
      <React.Fragment>
        <Accordion>
          <Accordion.Title onClick={expandAll ? () => {} : this.toggleAccordion} style={{backgroundColor: 'rgb(235,235,235)', paddingLeft: '10px', borderRadius: '5px 5px 0px 0px'}}>
            {
              totalSalesOrder > 0
              ?
              <Icon name='dropdown' style={active ? {rotate: '90deg'} : {}}/>
              :
              null
            }
            {orderType} ({totalSalesOrder})
          </Accordion.Title>
          <Accordion.Content active={active && totalSalesOrder > 0} style={{backgroundColor: 'rgb(245,245,245)'}}>
            {orders.map((x, index) =>
              <div style={{borderBottom: '1px solid rgb(212,212,212)', padding: '10px', paddingTop: '5px', textWrap: 'auto', lineHeight: '170%'}}>
                {x.quantity}{longDash}${x.sales_price}{orderMarginPercent(x.sales_price, marginCad, atsRepData) == null ? '' : <span style={{whiteSpace: 'nowrap'}}>{longDash} {orderMarginPercent(x.sales_price, marginCad, atsRepData)}%</span>}{longDash}{formatDate(x.date)}&nbsp;
                {longDash}{x.ponumber}{longDash}{_rep(x)}{longDash}{x.account_name}&nbsp;&nbsp;&nbsp;
                 {x.rts ? <span style={{backgroundColor: 'rgb(141,198,95)', padding: '4px 10px', borderRadius: '17px', color: 'white', whiteSpace: 'nowrap'}}>RTS <Icon name="check"/></span> : ''}
                 {ticketChipPopup(ticketInfo, x.ponumber)}
                 {poeChipPopup(poeInfo, x.ponumber)}
              </div>
            )}
            {
              true
              ?
              null
              :
              <Grid stackable columns={4}>
                {orders.map((x, index) =>
                  <React.Fragment>
                    <Grid.Row>
                      <Grid.Column>{x.quantity}</Grid.Column>
                      <Grid.Column>${x.sales_price}</Grid.Column>
                      <Grid.Column>{formatDate(x.date)}</Grid.Column>
                      <Grid.Column style={colStyle}>{x.ponumber}</Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={3} style={{marginTop: '-15px'}}>
                      <Grid.Column style={colStyle}>{_rep(x)}</Grid.Column>
                      <Grid.Column style={colStyle}>{x.account_name}</Grid.Column>
                      <Grid.Column>{x.rts ? <span style={{backgroundColor: 'rgb(141,198,95)', padding: '4px 10px', borderRadius: '17px', color: 'white'}}>RTS <Icon name="check"/></span> : ''}</Grid.Column>
                    </Grid.Row>
                  </React.Fragment>
                )}
              </Grid>
            }
          </Accordion.Content>
        </Accordion>
        {
          true //active && totalSalesOrder > 0
          ?
          null
          :
          <div>{totalSalesOrder}</div>
        }
      </React.Fragment>
    )
  }
}

export default SalesOrderAccordion
